$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p == "user" && a == "set_password") {
    if (window.innerWidth <= 768) {
      $("header, footer").hide();
    }
    $(window).on("resize", function () {
      if (window.innerWidth <= 768) {
        $("header, footer").hide();
      } else {
        $("header, footer").show();
      }
    });
    let user_set_password_ajax_lock = false;

    $(document).on("submit", "#user-set-password-form", function (e) {
      e.preventDefault();
      if (!user_set_password_ajax_lock) {
        user_set_password_ajax_lock = true;
        $.ajax({
          type: "POST",
          url: "/ajax/user/set_password",
          data: {
            serialized_post: $(this).serialize(),
          },
        })
          .done(function (data) {
            if (data.isAdmin === true) {
              document.location.href = "/admin/dashboard";
            } else if (data.isOrganizer === true) {
              document.location.href = "/settings";
            } else {
              $("#user-set-password-form").remove();
              $("#user-set-password-form-title").remove();
              if ($("#user-set-password-success-title").hasClass("d-none")) {
                $("#user-set-password-success-title").removeClass("d-none");
              }
              if ($("#user-set-password-success").hasClass("d-none")) {
                $("#user-set-password-success").removeClass("d-none");
              }
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              prependAlert(
                "#div-set-password-button",
                data.responseJSON.error_message,
                "danger",
                null,
                "#user-set-password-form"
              );
            }

            user_set_password_ajax_lock = false;
          })
          .always(function () {
            user_set_password_ajax_lock = false;
          });
      }

      return false;
    });
  }
});
